import { render, staticRenderFns } from "./testimonial-boxes.vue?vue&type=template&id=3e5076fe"
import script from "./testimonial-boxes.vue?vue&type=script&lang=js"
export * from "./testimonial-boxes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports